import React, { useContext } from 'react';

import { Table } from 'semantic-ui-react';

import { sortPlaceActions } from './PlaceActionsTable.utils';
import PlaceActionTableRow from './components/PlaceActionTableRow/PlaceActionTableRow';
import { PlaceActionsContext } from '../../contexts/PlaceActions.context';

import './PlaceActionsTable.scss';

const propTypes = {};

const defaultProps = {};

export default function PlaceActionsTable() {
  const { providerEntityAttributes } = useContext(PlaceActionsContext);

  const sortedData = sortPlaceActions(providerEntityAttributes);

  return (
    <Table className="place-actions-table" celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={5}>Action Type</Table.HeaderCell>
          <Table.HeaderCell width={8}>Link URL</Table.HeaderCell>
          <Table.HeaderCell width={2}>Primary Link</Table.HeaderCell>
          <Table.HeaderCell width={1} />
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {sortedData.map((action) => (
          <PlaceActionTableRow key={action.id} placeAction={action} />
        ))}
      </Table.Body>
    </Table>
  );
}

PlaceActionsTable.propTypes = propTypes;
PlaceActionsTable.defaultProps = defaultProps;
